import { render, staticRenderFns } from "./header-component.vue?vue&type=template&id=642d5e00&scoped=true"
import script from "./header-component.vue?vue&type=script&lang=js"
export * from "./header-component.vue?vue&type=script&lang=js"
import style0 from "./header-component.vue?vue&type=style&index=0&id=642d5e00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642d5e00",
  null
  
)

/* custom blocks */
import block0 from "@/locale/header-localization.json?vue&type=custom&index=0&blockType=i18n&issuerPath=C%3A%5CUsers%5Cnikod%5CDocuments%5Cgithub%5Cnikodz%5CWebmed.Core.VueJS%5Csrc%5Ccomponent%5Cheader-component.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports